// React Lib
import React from "react";
import classnames from 'classnames';
// Component Styles
import { useStyles } from "./FilterableChipStyles";
import { Color, FONT_FAMILY } from "../../constants";
import { Typography, Button } from '../index';
export const FilterableChip = (props) => {
    const classes = useStyles(props);
    const { id, data = [], activeFilter, onClick = () => { }, onClear, style, textClearFilter = 'Clear Filter', backgroundColor = Color.neutral[100] } = props;
    return (React.createElement("div", { style: { position: 'relative', width: '100%', background: backgroundColor }, id: id },
        data.map((data, index) => (React.createElement("div", { key: `data${index}`, style: {
                width: '90%',
                display: 'flex',
                alignItems: 'center',
                boxSizing: 'border-box',
                padding: 16,
            } },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_BOLD, size: 16, color: Color.neutral[900], style: { marginRight: 48 } }, data.textParameterName),
            data.filters.map((filter, index) => {
                const filterClasses = classnames({
                    [classes.chipContainer]: !activeFilter.includes(filter.id),
                    [classes.chipContainerActive]: activeFilter.includes(filter.id),
                    [classes.disabled]: filter.disabled,
                });
                return (React.createElement("div", { key: `filter${index}`, id: filter.id.toString(), className: filterClasses, style: style, onClick: onClick(filter.id) }, filter.textLabel));
            })))),
        React.createElement(Button, { type: "secondary", style: { position: 'absolute', right: 16, bottom: 12 }, onClick: onClear }, textClearFilter)));
};
export default React.memo(FilterableChip);
